import { makeStyles, Theme } from "@material-ui/core";
import { CreateCSSProperties } from "@material-ui/styles/withStyles";

export const CORE_CARD_STYLES: CreateCSSProperties<{}> = {
  backgroundColor: "#ffffff",
  borderRadius: 10,
  width: "100%"
};

interface IStyleProps {
  cardBorderLeftColor: string;
}

const useStyles = makeStyles<Theme, IStyleProps>(
  _theme => ({
    collapseArrowContainer: {
      "& path": {
        fill: "#0030FF"
      },
      "& > span": {
        position: "relative",
        right: 8
      },
      "& > span > svg": {
        transform: "rotate(270deg)"
      }
    },
    expandedCardContainer: {
      ...CORE_CARD_STYLES,
      height: "fit-content",
      padding: "24px 24px 0",
      borderLeft: ({ cardBorderLeftColor }) =>
        `10px solid ${cardBorderLeftColor}`
    },
    expandedCardContent: {
      height: "calc(100% - 60px)"
    },
    expandedCardFooter: {
      height: "60px",
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      borderTop: "1px solid lightgrey",
      marginTop: 12
    },
    formHelperTextProps: {
      margin: "8px 0"
    },
    largerTextFieldContainer: {
      "& div.MuiOutlinedInput-multiline": {
        minHeight: 97.5
      }
    },
    trashIconContainer: {
      "& > span": {
        position: "relative",
        top: 2
      },
      height: "fit-content",
      width: "fit-content",
      borderRadius: 100,
      backgroundColor: "#fcd2d5",
      padding: "4px 8px"
    },
    helperTextContainer: {
      alignItems: "center",
      display: "flex",
      gap: "4px"
    },
    infoWithCharCountContainer: {
      alignItems: "center",
      color: "#616161",
      display: "flex",
      gap: "4px",
      justifyContent: "space-between",
      width: "100%"
    },
    errorText: {
      color: "#EC5D77"
    }
  }),
  { name: "UnlockCodeCard" }
);

export default useStyles;
